import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { getProduct, getPublicProductBySlug } from '@/api/catalog';
import { productPath } from '@/lib/productUrl';
import { resolveSlugRedirect } from '@/api/seoRedirects';

export function LegacyProductRedirect() {
  const { id } = useParams<{ id: string }>();
  const [target, setTarget] = useState<string | null>(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    if (!id) {
      setMissing(true);
      return;
    }
    void (async () => {
      const product = await getProduct(id);
      if (product?.slug) {
        setTarget(productPath(product));
        return;
      }
      const redirected = await resolveSlugRedirect(id, 'product');
      if (redirected) {
        const p = await getPublicProductBySlug(redirected);
        setTarget(p ? productPath(p) : productPath({ id, slug: redirected, parish: undefined }));
        return;
      }
      setMissing(true);
    })();
  }, [id]);

  if (target) return <Navigate to={target} replace />;
  if (missing) return <Navigate to="/grenada/shop" replace />;
  return null;
}
